import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PSAcuerdoPosteriorModel } from '../models/ps-acuerdo-posterior-model';

@Injectable({
  providedIn: 'root'
})
export class PsAcuerdoPosteriorService {

  myAppUrl: string;

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getAllById(idPs: number) {
    return this._http.get(`${ this.myAppUrl }api/PS_AcuerdoPosterior/${idPs}`);
  }

  post(item: PSAcuerdoPosteriorModel) {
    console.log(item)
    return this._http.post<PSAcuerdoPosteriorModel>(`${ this.myAppUrl }api/PS_AcuerdoPosterior`, item);
  }

  getTipoAcuerdoPosteriorList() {
    return this._http.get(`${ this.myAppUrl }api/PS_AcuerdoPosterior/TipoAcuerdoPosterior`);
  }

}
